import {
  createManagementClient,
  type ManagementClient,
} from '@peacock/sdk-js';

/**
 * Returns a fresh ManagementClient bound to the given token. Re-
 * creating the client per render is cheap (no internal state beyond
 * the closure) and avoids stale-token bugs where a logout-then-login
 * would otherwise carry the old client into a Query.
 *
 * `baseUrl` defaults to the same-origin `/` so dev (Vite proxies
 * `/v1` to the API at :8001) and SaaS-mode (admin + api share a
 * subdomain) both work without env wiring. Self-host with a separate
 * origin can set `VITE_PEACOCK_API_BASE_URL`.
 */
export function makeApi(token: string): ManagementClient {
  const envBase = import.meta.env.VITE_PEACOCK_API_BASE_URL;
  const baseUrl =
    typeof envBase === 'string' && envBase.length > 0
      ? envBase.replace(/\/+$/, '')
      : window.location.origin;

  return createManagementClient({
    baseUrl,
    token,
  });
}
